export const RLU_PATH = 'api/rlu'

export enum EndPoints {
    GetPartSpecs = 'GetPartSpecs',
}